import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantLogoDto } from '../models/auth/pagepermissions';
import { RootState } from '../redux/store';

interface TenantState {
  tenantLogos: TenantLogoDto | null;
  permittedPages: string[];
}

const initialState: TenantState = {
  tenantLogos: null,
  permittedPages: [],
};

const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setTenantLogos: (state, action: PayloadAction<TenantLogoDto | null>) => {
      state.tenantLogos = action.payload;
    },
    setPermittedPages: (state, action: PayloadAction<string[]>) => {
      state.permittedPages = action.payload;
    },
    clearTenantData: (state) => {
      state.tenantLogos = null;
      state.permittedPages = [];
    },
  },
});

export const { setTenantLogos, setPermittedPages, clearTenantData } = tenantSlice.actions;

// Selectors
export const selectTenantLogos = (state: RootState) => state.tenant.tenantLogos;
export const selectPermittedPages = (state: RootState) => state.tenant.permittedPages;

// Helper to get image src from base64
export const selectTenantLogoSrc = (state: RootState): string | null => {
  const logos = state.tenant.tenantLogos;
  if (logos?.logo && logos?.logoMimeType) {
    return `data:${logos.logoMimeType};base64,${logos.logo}`;
  }
  return null;
};

export const selectTenantSmallLogoSrc = (state: RootState): string | null => {
  const logos = state.tenant.tenantLogos;
  if (logos?.smallLogo && logos?.smallLogoMimeType) {
    return `data:${logos.smallLogoMimeType};base64,${logos.smallLogo}`;
  }
  return null;
};

export default tenantSlice.reducer;

